import * as React from "react";
import { Button, ButtonProps } from "@mui/material";
import { forwardRef, Ref, useRef } from "react";

export interface IAppButtonProps extends ButtonProps {
    enableDoubleClickForOnClick?: boolean;
}

let buttonCounter = 0;

export const AppButton = forwardRef((props: IAppButtonProps, ref: Ref<HTMLButtonElement>) => {
    const clickTimer = useRef(0);
    const buttonId = useRef("");
    const { enableDoubleClickForOnClick, ...rest } = props;

    if (!buttonId.current) {
        buttonCounter++;
        buttonId.current = "appButton_" + buttonCounter.toString(10);
    }

    const clearPressTimer = () => {
        clearTimeout(clickTimer.current);
        clickTimer.current = 0;
    };
    
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        //Prevent double click on button
        if (!enableDoubleClickForOnClick) {
            if (clickTimer.current) return;
            clickTimer.current = window.setTimeout(() => {
                clearPressTimer();
            }, 500);
        }
        //Run blur on active element before click
        const activeElement: any = document.activeElement;
        if (activeElement && activeElement.blur && activeElement.id !== buttonId.current) {
            activeElement.blur();
            window.setTimeout(() => {
                props.onClick(event);
            }, 50);
            return;
        }
        //Run click event without blur
        props.onClick(event);
    };

    return (
        <Button id={buttonId.current} ref={ref} {...rest} onClick={handleClick}>
            {rest.children}
        </Button>
    );
});

AppButton.displayName = "AppButton";